module.exports = __webpack_public_path__ + "img/nt51-00a-80-1_1.prt.d09e3c10.jpg";